import { Outlet } from 'react-router';
import { env } from '@/core/env';
import { AsideLayout, type AsideItem } from './AsideMenu';

const items: AsideItem[] = [
  { label: 'Authorisation Codes', icon: 'key', to: '/home/settings/authorisation-codes' },
  { label: 'Apply for Presenter ID', icon: 'open_in_new', onClick: () => window.open(env.applyPresenterUrl, '_blank') },
  { label: 'Report Format', icon: 'table_chart', to: '/home/settings/reports-formate' },
  { label: 'Accountants', icon: 'account_box', to: '/home/settings/accountants' },
  // 3.0 General Settings menu: Limited Company opens on every framework (UK-GAAP / FRS102 / FRS105) and lists them.
  {
    label: 'Limited Company',
    icon: 'business',
    to: '/home/settings/limited-company',
    alsoActiveFor: ['/home/settings/limited-company-FRS102', '/home/settings/limited-company-FRS105'],
    subItems: [
      { label: 'UK-GAAP', to: '/home/settings/limited-company' },
      { label: 'FRS102', to: '/home/settings/limited-company-FRS102' },
      { label: 'FRS102 Section 1A', to: '/home/settings/limited-company-FRS102?section=1A' },
      { label: 'FRS105', to: '/home/settings/limited-company-FRS105' },
    ],
  },
  { label: 'LLP', icon: 'store', to: '/home/settings/llp' },
  { label: 'Partnership', icon: 'handshake', to: '/home/settings/partnership' },
  { label: 'Sole Trader', icon: 'maps_home_work', to: '/home/settings/sole-trader' },
  { label: 'Email Templates', icon: 'email', to: '/home/settings/email-templates' },
  { label: 'Chart of Accounts', icon: 'analytics', to: '/home/settings/chart-accounts' },
  { label: 'Logo on Report', icon: 'image', to: '/home/settings/logo-report' },
  { label: 'Data Security', icon: 'verified_user', to: '/home/settings/data-security' },
  // Angular gives this item the icon title "Logo on Report" (copy/paste); kept as is.
  { label: 'Update Directors', icon: 'image', to: '/home/settings/update-directors', iconTitle: 'Logo on Report' },
];

export function SettingsLayout() {
  return (
    // Design review 2 Nov: these pages have no second-level menu, so the floating collapse arrow had nothing to collapse and
    // hung on the edge of the rail. The rail stays open.
    <AsideLayout items={items} collapsible={false}>
      <Outlet />
    </AsideLayout>
  );
}
